// src/components/JarvislySimpleComponents/SimpleLoadingApp.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import React from 'react';
import useZustand from 'hooks/useZustand';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { printGlobalStateToConsole } from 'configs/ConfigIndex';
import translateX from 'utils/translateX';
import {
  StyledContentCenter,
  StyledCover,
  StyledTitleCenter,
} from 'layouts/SharedComponents/StyledComponents';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const DefaultIcon = <LoadingOutlined style={{ fontSize: 35 }} spin />;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleLoadingApp = ({ visible = true, icon, title, translucid }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const storedLoadingApp = useZustand('boot', 'loadingApp', true, true);
  const currentTheme = useZustand('theme', 'currentTheme');

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const show = storedLoadingApp?.visible ?? visible;
  const isTranslucid = translucid ?? !!storedLoadingApp?.translucid;

  const iconNode =
    icon === false
      ? null
      : (icon ??
        (storedLoadingApp?.icon === false ? null : (storedLoadingApp?.icon ?? DefaultIcon)));
  const finalTitle = title ?? storedLoadingApp?.title;
  const tip = finalTitle ? translateX(finalTitle) : null;

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return show ? (
    <StyledCover
      translucid={isTranslucid}
      currentTheme={currentTheme}
      onDoubleClick={printGlobalStateToConsole}
      style={{
        zIndex: 2000,
        fontSize: 16,
      }}
    >
      <StyledContentCenter>
        {iconNode ? <Spin size="large" indicator={iconNode} /> : null}
        {tip ? <StyledTitleCenter currentTheme={currentTheme}>{translateX(tip)}</StyledTitleCenter> : null}
      </StyledContentCenter>
    </StyledCover>
  ) : null;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleLoadingApp;
